import React, { Component, Fragment } from 'react';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import Select from 'react-select';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router-dom';


const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Este campo es obligatorio!
      </div>
    );
  }
};

class Tabselling extends Component {
  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeOldPrice = this.onChangeOldPrice.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.onChangePrice = this.onChangePrice.bind(this);
    this.handleProductChange = this.handleProductChange.bind(this);

    this.state = {
      loading: true,
      name: '',
      old_price: '',
      price: '',
      status: 'ACTIVATED',
      id_product: null,
      allProducts: [],
      selectedProduct: null,
      errors: {},
    };
  }

  componentWillMount() {
    // Primero los productos (para el picker), después la oferta -- así,
    // apenas llega la oferta, ya podemos armar el "selectedProduct" que
    // corresponde buscándolo en la lista de productos ya cargada. Antes
    // este form no tenía picker de producto ni mostraba a cuál estaba
    // ligada la oferta.
    this.getDataAllProducts(() => this.getSelling());
  }

  // Mismo endpoint que usa el modal "Nueva oferta" de list-selling.js
  // (ApiService.getProductStock -> GET /products_stock), no uno nuevo.
  getDataAllProducts(cb) {
    const user = AuthService.getCurrentUser();
    ApiService.getProductStock(user.token).then(
      (res) => {
        if (res && res.status === 'success') {
          const rows = (res.data || []).slice().sort((a, b) => {
            const aHas = (parseFloat(a.stock) || 0) > 0 ? 0 : 1;
            const bHas = (parseFloat(b.stock) || 0) > 0 ? 0 : 1;
            if (aHas !== bHas) return aHas - bHas;
            return String(a.name).localeCompare(String(b.name), 'es', { sensitivity: 'base' });
          });
          const products = rows.map(function (row) {
            const stock = parseFloat(row.stock) || 0;
            const sizeLabel = row.size && row.size.trim() ? ` (${row.size.trim()})` : '';
            const priceLabel = row.price ? ` - $${row.price}` : '';
            const stockLabel = stock > 0 ? ` (${stock} en stock)` : ' (sin stock)';
            return {
              value: row.id,
              label: row.name + sizeLabel + priceLabel + stockLabel,
            };
          });
          this.setState({ allProducts: products }, cb);
        } else if (cb) {
          cb();
        }
      },
      () => {
        if (cb) cb();
      }
    );
  }

  getSelling() {
    var user = AuthService.getCurrentUser();
    let id_selling = this.props.match.params.id;
    ApiService.getSellingDetails(user.token, id_selling).then(
      (res) => {
        if (res && res.status === 'success') {
          const selling = res.data;
          // El producto ligado a la oferta puede no aparecer en /product-stock
          // (solo trae productos ACTIVATED -- si este producto o su padre se
          // desactivó después de crear la oferta, no aparece ahí). En ese caso
          // se arma una opción con el nombre real que ya manda el backend
          // (resolveProductPreview, no filtra por status) para que al menos se
          // vea qué producto es y su presentación, aunque no esté en la lista
          // de búsqueda del picker.
          const match = this.state.allProducts.find((p) => p.value === selling.id_product);
          const fallbackProduct = !match && selling.product_name
            ? { value: selling.id_product, label: `${selling.product_name} (inactivo / sin stock)` }
            : null;
          this.setState({
            loading: false,
            name: selling.name,
            old_price: selling.old_price,
            price: selling.price,
            status: selling.status,
            id_product: selling.id_product,
            selectedProduct: match || fallbackProduct,
          });
        } else {
          this.setState({ loading: false });
          toast.error((res && res.message) || 'No se pudo cargar la oferta');
        }
      },
      (error) => {
        this.setState({ loading: false });
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      }
    );
  }

  handleProductChange(selectedProduct) {
    this.setState({
      selectedProduct,
      id_product: selectedProduct ? selectedProduct.value : null,
    });
  }

  onChangeStatus(e) {
    this.setState({
      status: e.target.value,
    });
  }

  onChangeName(e) {
    this.setState({
      name: e.target.value,
    });
  }

  onChangeOldPrice(e) {
    this.setState({
      old_price: e.target.value,
    });
  }

  onChangePrice(e) {
    this.setState({
      price: e.target.value,
    });
  }

  handleUpdate(e) {
    if (!this.state.id_product) {
      toast.error('Selecciona un producto');
      return;
    }

    this.setState({
      message: '',
      loading: true,
    });

    this.form.validateAll();

    if (
      this.checkBtn.context._errors.length === 0
    ) {
      var user = AuthService.getCurrentUser();
      let data_selling = {};
      data_selling['id'] = this.props.match.params.id;
      data_selling['id_product'] = this.state.id_product;
      data_selling['name'] = this.state.name;
      data_selling['price'] = this.state.price;
      data_selling['old_price'] = this.state.old_price;
      data_selling['status'] = this.state.status;


      ApiService.putSelling(user.token, data_selling).then(
        (res) => {
          if (res) {
            if (res && res.status == 'success') {
              toast.success('up selling actualizado!');
              this.props.history.push('/list-selling');
            } else {
              this.setState({ loading: false });
              toast.error(res.message);
            }
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      const errors = {};

      // Actualiza el estado con los errores encontrados
      this.setState({ errors, loading: false }, () => {
        });
      }

  }


  formPreventDefault(e) {
    e.preventDefault();
  }

  render() {
    return (
      <Fragment>
        <Tabs>
          <TabList className="nav nav-tabs tab-coupon">
            <Tab className="nav-link">Up selling</Tab>

          </TabList>
          <TabPanel>
            <Form

              autoComplete="off"
              ref={(c) => {
                this.form = c;
              }}
              onSubmit={this.formPreventDefault}
            >
              <h4>Datos </h4>
              <div>
                <div className="form-group">
                  <label className="col-xl-3 col-md-4">
                    <span>*</span> Producto
                  </label>
                  <div style={{ maxWidth: '100%', margin: '5px' }}>
                    <Select
                      value={this.state.selectedProduct}
                      onChange={this.handleProductChange}
                      options={this.state.allProducts}
                      placeholder="Busca un producto..."
                      isClearable={true}
                      isDisabled={this.state.loading}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="col-xl-3 col-md-4">
                    <span>*</span> Nombre
                  </label>
                  <Input
                    name="name"
                    value={this.state.name}
                    type="text"
                    className="form-control"
                    style={{ maxWidth: '100%' , margin:'5px' }}
                    onChange={this.onChangeName}
                    validations={[required]}
                  />
                </div>
                <div className="form-group">
                  <label className="col-xl-3 col-md-4">
                    <span>*</span> Precio
                  </label>
                  <Input
                    name="old_price"
                    value={this.state.old_price}
                    type="text"
                    className="form-control"
                    style={{ maxWidth: '100%' , margin:'5px' }}
                    onChange={this.onChangeOldPrice}
                    validations={[required]}
                  />
                </div>
                <div className="form-group">
                  <label className="col-xl-3 col-md-4">
                    <span>*</span> Precio nuevo
                  </label>
                  <Input
                    name="price"
                    value={this.state.price}
                    type="text"
                    className="form-control"
                    style={{ maxWidth: '100%' , margin:'5px' }}
                    onChange={this.onChangePrice}
                    validations={[required]}
                  />
                </div>
                <div className="form-group">
              <label className="col-xl-3 col-md-4">
                <span>*</span> Estado
              </label>
              <div className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
              <label className="d-block" style={{ marginRight: '1rem', marginLeft: '2rem' }}>
                  <Input
                    id="edo-ani"
                    name="status"
                    value="ACTIVATED"
                    type="radio"
                    className="radio_animated"
                    checked={this.state.status === 'ACTIVATED'}
                    onChange={this.onChangeStatus}
                    validations={[required]}
                  />
                  ACTIVADO
                </label>
                <label className="d-block">
                  <Input
                    id="edo-ani"
                    name="status"
                    value="DESACTIVATED"
                    type="radio"
                    className="radio_animated"
                    checked={this.state.status === 'DESACTIVATED'}
                    onChange={this.onChangeStatus}
                    validations={[required]}
                  />
                DESACTIVADO
                </label>
              </div>
            </div>
            </div>
              <button
                onClick={() => this.handleUpdate()}
                className="btn btn-primary"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Guardar</span>
              </button>


              {this.state.message && (
                <div className="form-group">
                  <div className="alert alert-danger" role="alert">
                    {this.state.message}
                  </div>
                </div>
              )}
              <CheckButton
                style={{ display: 'none' }}
                ref={(c) => {
                  this.checkBtn = c;
                }}
              />
            </Form>
          </TabPanel>

        </Tabs>

      </Fragment>
    );
  }
}

//export default Tabset_user;
export default withRouter (Tabselling);
